import cn from 'classnames'
import type { HTMLAttributes } from 'react'
import React from 'react'
import styles from './waveform.styles.module.css'

// Note: The controls hover effect is handled with a more direct approach below

/** The wave container */
export const WaveContainer = (props: HTMLAttributes<HTMLDivElement>) => (
  <div {...props} className={cn(styles.waveContainer, props.className)} style={props.style} />
)

export const PeaksPlaceholder = (props: HTMLAttributes<HTMLDivElement>) => (
  <div {...props} className={cn(styles.peaksPlaceholder, props.className)} style={props.style} />
)

export const Timeline = (props: HTMLAttributes<HTMLDivElement>) => <div {...props} />

export const RangeOverlay = (props: HTMLAttributes<HTMLDivElement>) => (
  <div {...props} className={cn(styles.rangeOverlay, props.className)} style={props.style} />
)

export const Fabs = (props: HTMLAttributes<HTMLDivElement>) => (
  <div {...props} className={cn(styles.fabs, props.className)} style={props.style} />
)

export const RecorderFab = (props: HTMLAttributes<HTMLDivElement>) => (
  <div {...props} className={cn(styles.recorderFab, props.className)} style={props.style} />
)

interface FabProps extends HTMLAttributes<HTMLDivElement> {
  isVisible?: boolean
  component?: React.ElementType
}

export const Fab = ({ isVisible, component: _component, ...props }: FabProps) => (
  <div
    {...props}
    className={cn(styles.fab, isVisible && styles['fab--visible'], props.className)}
    style={props.style}
  />
)

export const Controls = (props: HTMLAttributes<HTMLDivElement>) => (
  <div {...props} className={cn(styles.controls, props.className)} style={props.style} />
)
